module.exports = __webpack_public_path__ + "img/zi.f2b46d8a.png";